<template>
  <div class="pr-md-5 pl-md-5 pr-3 pl-3">
  
    <div class="row">

        <div class="col-md-4 w-100 text-center">
              <h5 class="font-weight-bold text-uppercase mt-3 mb-1">Adresse</h5>
              <p class="font-italic text-muted mb-2">Avenue Farhat Hached, 3000, Sfax, Tunisie</p>
        </div>


        <div class="col-md-4 w-100 text-center">
              <h5 class="font-weight-bold text-uppercase mt-3 mb-1">Téléphone</h5>
              <p class="font-italic text-muted mb-2">+216 74 204 700</p>
        </div>


        <div class="col-md-4 w-100 text-center">
              <h5 class="font-weight-bold text-uppercase mt-3 mb-1">Email</h5>
              <p class="font-italic text-muted mb-2">contact@sopiq.tn</p>
        </div>

    </div>


    <div class="row mt-3">
      <div class="col-12">
        <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3278.904119974871!2d10.756855900000001!3d34.7328111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13002d2bcd0c6b09%3A0x4ec3cf61e36fbf09!2sSOPIQ!5e0!3m2!1sfr!2stn!4v1751032584186!5m2!1sfr!2stn" 
          width="100%"
          height="100%"
          frameborder="0"
          style="border: 0; min-height: 400px;"
          allowfullscreen  
        ></iframe>
      </div>
    </div>

    <div class="row mt-3">

      <div class="col-md-6 col-12 p-4">
          <input
            type="text"
            class="form-control mb-3"  style="border-radius: 9px !important;"
            placeholder="Votre nom & prénom"
            v-model="contactUs.firstName"
          />
          <input
            type="text"
            class="form-control mb-3"  style="border-radius: 9px !important;"
            placeholder="Votre téléphone"
            v-model="contactUs.secondName"
          />
          <input
            type="email"
            class="form-control mt-3"  style="border-radius: 9px !important;"
            placeholder="Votre adresse mail"
            v-model="contactUs.mail"
          />
      </div>

      <div class="col-md-6 col-12 p-4">
          <textarea
                  class="form-control mb-3 h-100"  style="border-radius: 9px !important;"
                  rows="4"
                  placeholder="Votre Message"
                  v-model="contactUs.message"
                ></textarea>
      </div>

      <div class="col-12 text-right p-4">
        <b-button variant="warning" class="text-uppercase font-weight-bold font-size-16 px-4 py-2" @click="sendContactUsMail">Envoyer le message</b-button>
      </div>


    </div>

  </div>
</template>

<script>
import ContactUsApi from "@/services/contact-us-api";

export default {
  data() {
    return {
            contactUs:{ firstName: '' , secondName: '' , mail: '' , message:''},
    };
  },
  methods: {
    sendContactUsMail() {

        if(!this.contactUs.firstName || !this.contactUs.secondName || !this.contactUs.mail || !this.contactUs.message){
            this.$snotify.error('Veuillez remplir tous les champs');
            return;
        }

        if(!this.contactUs.mail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)){
            this.$snotify.error('Veuillez entrer une adresse email valide');
            return;
        }

        if(this.contactUs.message.length < 10){
            this.$snotify.error('Le message doit contenir au moins 10 caractères');
            return;
        }

        const phone = this.contactUs.secondName.replace(/\s+/g, '');
        if(!/^\+?\d{8,15}$/.test(phone)){
            this.$snotify.error('Veuillez entrer un numéro de téléphone valide');
            return;
        }

          

        ContactUsApi.sendContactUsMail(this.contactUs).then((result)=>{
          if(result){
              this.contactUs={ firstName: '' , secondName: '' , mail: '' , message:''}
          }
        })
    },
  },
};
</script>
<style scoped>
.underline {
  width: 50px;
  height: 4px;
  background-color: #d90100;
}
.bg-dark {
  background-color: #2c2f33 !important;
}
.form-control {
  border-radius: 0;
  height: 45px;
}
textarea.form-control {
  height: auto;
}
</style>
